export const emptyFunction = () => { };
